import _ from 'lodash'
export { updatedServices } from './update-services'
import { local } from '/data/lib/local-json'

import Client from "data/_client"

export async function getMigrations(property, force=false) {
  if(!local('auth.token')) return
  return Client.post(`migration/property/${property.propertyid}`, {check: !force})
}

export async function getFolderMigrations(folderid) {
  if(!local('auth.token')) return
  return Client.post(`migration/folder/${folderid}`)
}
